<template>
  <svg
    v-if="icon === 'pages-hr'"
    :width="width ? width : 24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5355 12.8118H18.6794C18.8686 13.3297 18.972 13.8887 18.972 14.4713V21.4862C18.972 21.7291 18.9297 21.9623 18.8528 22.1791H21.9213C23.0675 22.1791 24 21.2466 24 20.1004V16.2763C24 14.366 22.4458 12.8118 20.5355 12.8118Z"
      :fill="color"
    />
    <path
      d="M5.02806 14.4716C5.02806 13.8889 5.13142 13.33 5.3206 12.812H3.46454C1.55419 12.812 0 14.3662 0 16.2765V20.1007C0 21.2469 0.932486 22.1794 2.07872 22.1794H5.14726C5.07034 21.9624 5.02806 21.7293 5.02806 21.4864V14.4716Z"
      :fill="color"
    />
    <path
      d="M14.1217 11.0071H9.87847C7.96813 11.0071 6.41394 12.5613 6.41394 14.4716V21.4865C6.41394 21.8691 6.72416 22.1794 7.10685 22.1794H16.8933C17.276 22.1794 17.5862 21.8692 17.5862 21.4865V14.4716C17.5862 12.5613 16.032 11.0071 14.1217 11.0071Z"
      :fill="color"
    />
    <path
      d="M12 1.82056C9.70259 1.82056 7.8335 3.68965 7.8335 5.98714C7.8335 7.5455 8.69361 8.90652 9.96382 9.62109C10.5663 9.95999 11.2609 10.1537 12 10.1537C12.7392 10.1537 13.4337 9.95999 14.0362 9.62109C15.3065 8.90652 16.1666 7.54546 16.1666 5.98714C16.1666 3.6897 14.2975 1.82056 12 1.82056Z"
      :fill="color"
    />
    <path
      d="M4.68365 5.7041C2.96544 5.7041 1.56763 7.10192 1.56763 8.82012C1.56763 10.5383 2.96544 11.9361 4.68365 11.9361C5.11949 11.9361 5.53453 11.8459 5.91154 11.6836C6.56339 11.4029 7.10086 10.9062 7.43344 10.2839C7.66687 9.84716 7.79967 9.34892 7.79967 8.82012C7.79967 7.10196 6.40185 5.7041 4.68365 5.7041Z"
      :fill="color"
    />
    <path
      d="M19.3165 5.7041C17.5983 5.7041 16.2004 7.10192 16.2004 8.82012C16.2004 9.34897 16.3332 9.8472 16.5667 10.2839C16.8993 10.9062 17.4367 11.403 18.0886 11.6836C18.4656 11.8459 18.8806 11.9361 19.3165 11.9361C21.0347 11.9361 22.4325 10.5383 22.4325 8.82012C22.4325 7.10192 21.0347 5.7041 19.3165 5.7041Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'pages-hr-employees'"
    :width="width ? width : 25"
    :height="height ? height : 14"
    viewBox="0 0 25 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M22.0322 8.09195C21.7049 8.52244 21.3095 8.89839 20.8619 9.20331C21.3358 10.1207 21.6037 11.1611 21.6037 12.2629V13.2683C21.6037 13.5251 21.5583 13.7715 21.4751 14H24.3234C24.6836 14 24.9756 13.708 24.9756 13.3478V12.4517C24.9756 10.4807 23.7562 8.78936 22.0322 8.09195Z"
        :fill="color"
      />
      <path
        d="M17.828 6.24359C18.7027 6.66861 19.4718 7.27793 20.0834 8.02188C21.018 7.37754 21.6321 6.30022 21.6321 5.08173C21.6321 3.11354 20.0308 1.51227 18.0626 1.51227C17.8845 1.51227 17.71 1.52661 17.5389 1.55217C17.9577 2.35032 18.1951 3.25797 18.1951 4.22012C18.1951 4.93188 18.065 5.61368 17.828 6.24359Z"
        :fill="color"
      />
      <path
        d="M4.08907 9.2519C3.6222 8.94566 3.20966 8.56327 2.86917 8.12244C1.18449 8.83795 0 10.5091 0 12.4517V13.3478C0 13.708 0.292 14 0.652146 14H3.50044C3.41732 13.7715 3.37185 13.5251 3.37185 13.2683V12.2629C3.3719 11.1804 3.63063 10.1574 4.08907 9.2519Z"
        :fill="color"
      />
      <path
        d="M7.32788 1.5505C7.16037 1.52601 6.98949 1.51221 6.81529 1.51221C4.8471 1.51221 3.24583 3.11347 3.24583 5.08166C3.24583 6.32747 3.88783 7.42561 4.85788 8.06439C5.45359 7.32761 6.20227 6.71976 7.0552 6.28888C6.8072 5.64644 6.67085 4.94898 6.67085 4.22015C6.67085 3.25728 6.90856 2.34908 7.32788 1.5505Z"
        :fill="color"
      />
      <path
        d="M11.7468 13.2683V9.94118C10.0878 9.74342 8.64307 8.8383 7.72365 7.53659C5.98492 8.39986 4.78653 10.1936 4.78653 12.2629V13.2683C4.78653 13.6724 5.11414 14 5.51824 14H12.4785C12.0744 14 11.7468 13.6724 11.7468 13.2683Z"
        :fill="color"
      />
      <path
        d="M13.2102 9.92962V13.2683C13.2102 13.6724 12.8826 14 12.4785 14H19.4574C19.8615 14 20.1891 13.6724 20.1891 13.2683V12.2629C20.1891 10.1613 18.953 8.34367 17.1701 7.49664C16.2688 8.79572 14.8477 9.70786 13.2102 9.92962Z"
        :fill="color"
      />
      <path
        d="M12.4329 8.45098C14.7696 8.45098 16.6638 6.55675 16.6638 4.2201C16.6638 1.88345 14.7696 -0.0107727 12.4329 -0.0107727C10.0963 -0.0107727 8.20206 1.88345 8.20206 4.2201C8.20206 6.55675 10.0963 8.45098 12.4329 8.45098Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'pages-hr-employees_group'"
    :width="width ? width : 15"
    :height="height ? height : 14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M0 9.58006C0.112601 9.33684 0.304397 9.2644 0.56563 9.26665C1.62332 9.27641 2.68102 9.27078 3.73871 9.27078C4.08477 9.27078 4.24316 9.42992 4.24316 9.77711C4.24316 10.8491 4.24316 11.9208 4.24316 12.9922C4.24316 13.3214 4.08064 13.4847 3.75523 13.4851C2.69303 13.4851 1.63046 13.4798 0.568257 13.4899C0.304021 13.4922 0.112601 13.4182 0 13.1762V9.58006Z"
        :fill="color"
      />
      <path
        d="M12.2558 13.4858C11.7086 13.4858 11.1612 13.4858 10.6137 13.4858C10.3135 13.4858 10.1431 13.3154 10.1427 13.0166C10.1427 11.9216 10.1427 10.8268 10.1427 9.73205C10.1427 9.44267 10.3157 9.27189 10.6077 9.27151C11.712 9.27151 12.8162 9.27151 13.9205 9.27151C14.2117 9.27151 14.384 9.44267 14.3844 9.7328C14.3844 10.8278 14.3844 11.9226 14.3844 13.0174C14.3844 13.3176 14.2132 13.4847 13.9122 13.485C13.36 13.485 12.8078 13.485 12.2558 13.485V13.4858Z"
        :fill="color"
      />
      <path
        d="M7.19331 13.4858C6.65057 13.4858 6.10771 13.4858 5.56473 13.4858C5.25508 13.4858 5.0858 13.3184 5.08543 13.011C5.08543 11.921 5.08543 10.8308 5.08543 9.74031C5.08543 9.44004 5.25583 9.27151 5.5561 9.27151C6.64657 9.27151 7.73679 9.27151 8.82677 9.27151C9.12703 9.27151 9.29969 9.44079 9.30006 9.73843C9.30006 10.8334 9.30006 11.9283 9.30006 13.023C9.30006 13.3135 9.12779 13.4843 8.8369 13.485C8.28929 13.485 7.74167 13.485 7.19443 13.485L7.19331 13.4858Z"
        :fill="color"
      />
      <path
        d="M7.37874 2.52601C7.49134 2.54815 7.58217 2.56354 7.67187 2.58418C8.59632 2.79212 9.29107 3.64713 9.2997 4.58697C9.30233 4.87636 9.13043 5.05652 8.84367 5.05689C7.74269 5.05689 6.64283 5.05689 5.5441 5.05689C5.25584 5.05689 5.08356 4.87823 5.08581 4.5896C5.0937 3.59083 5.87402 2.69791 6.86152 2.55528C6.90353 2.54982 6.94458 2.53858 6.98351 2.52188C6.64571 2.44681 6.36721 2.28241 6.16715 2.00016C6.06883 1.86848 5.99853 1.71805 5.96057 1.55815C5.92261 1.39826 5.91781 1.23228 5.94646 1.07046C6.05643 0.427883 6.58453 -0.0123855 7.22635 0.00112657C7.85053 0.013888 8.36362 0.484558 8.44957 1.123C8.53552 1.76145 8.12828 2.30531 7.37874 2.52601Z"
        :fill="color"
      />
      <path
        d="M11.8283 7.59078H7.61366C7.61366 7.71765 7.61366 7.84188 7.61366 7.96612C7.61141 8.23786 7.43651 8.42778 7.19104 8.42703C6.94557 8.42628 6.77291 8.23599 6.77104 7.96312C6.77104 7.84226 6.77104 7.72178 6.77104 7.59304H2.5564C2.5564 7.72778 2.5564 7.85765 2.5564 7.98714C2.55227 8.23936 2.37549 8.4244 2.1394 8.42741C1.89844 8.43079 1.71602 8.24274 1.7134 7.98414C1.71077 7.72553 1.71114 7.46955 1.7134 7.21207C1.7134 6.9118 1.88342 6.74177 2.18294 6.74177C3.65275 6.74177 5.12256 6.74177 6.59238 6.74177H6.77104C6.77104 6.59915 6.76916 6.46928 6.77104 6.33979C6.77517 6.08831 6.95082 5.9029 7.18616 5.89952C7.42149 5.89614 7.60954 6.08419 7.61366 6.34129C7.61592 6.46778 7.61366 6.59389 7.61366 6.74177H7.77956H12.1605C12.5155 6.74177 12.6698 6.89829 12.6702 7.25711C12.6702 7.49582 12.6702 7.73454 12.6702 7.97325C12.6683 8.23599 12.4953 8.42365 12.2551 8.42778C12.0148 8.43191 11.8306 8.24011 11.8279 7.97137C11.8272 7.84939 11.8283 7.72816 11.8283 7.59078Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconsPagesHR',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#A2D5F1',
    },
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
  },
}
</script>

<style scoped></style>
